<ngx-spinner [name]="'consultar-produto'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Consultar Produto</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <form [formGroup]="consultaForm" *ngIf="!bConsulta">
            <div class="row">
                <div class="col-auto">
                    <mat-form-field appearance="fill" [floatLabel]="'always'">
                        <mat-label>Tipo de Busca</mat-label>
                        <mat-select formControlName="tipoBusca" name="tipoBusca">
                            <mat-option [value]="true">
                                Começando com
                            </mat-option>
                            <mat-option [value]="false">
                                Contendo
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-sm" *ngIf="g.tipoBusca.value">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Descrição (Nome do Produto)</mat-label>
                        <input type="text" matInput formControlName="nomeProduto" maxlength="100"
                            (keypress)="omit_special_char($event)" [matAutocomplete]="auto"
                            (ngModelChange)="onChangeNomeProduto($event)">
                        <mat-hint *ngIf="bCaracterEspecial" align="start" style="color: red;"> Não são permitidos
                            acentos ou
                            caracteres especiais </mat-hint>
                    </mat-form-field>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let prod of produtos" [value]="prod.Nome"
                            (onSelectionChange)="detalharProduto(prod)">
                            {{prod.Nome}}
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <div class="col-auto" *ngIf="!g.tipoBusca.value">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Contendo</mat-label>
                        <input type="text" matInput formControlName="contendo" maxlength="100">
                    </mat-form-field>
                </div>

                <div class="col-auto">
                    <mat-form-field appearance="fill" [floatLabel]="'always'">
                        <mat-label>Grupo</mat-label>
                        <mat-select formControlName="grupo" name="gp">
                            <mat-option *ngFor="let gp of grupos" [value]="gp.idGrupo">
                                {{gp.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-2">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Código de Barras</mat-label>
                        <input type="text" matInput formControlName="codBarras" maxlength="13"
                            [matAutocomplete]="autoCod" (ngModelChange)="onChangeCodigoBarras($event)">
                    </mat-form-field>
                    <mat-autocomplete #autoCod="matAutocomplete">
                        <mat-option *ngFor="let prod of produtos" [value]="prod.CodigoBarras">
                            {{prod.Nome}} - {{prod.CodigoBarras}}
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <div class="col-auto">
                    <button class="mt-4" mat-flat-button color="primary" (click)="consultarTodosProdutos()">
                        <mat-icon>search</mat-icon> Buscar
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-auto" *ngIf="!atualizarExcel">
                    <button mat-flat-button color="primary" (click)="atualizarPrecosExcel()">
                        <mat-icon>upload</mat-icon> Atualizar preços em demanda
                    </button>
                </div>

                <div class="col-auto" *ngIf="atualizarExcel">
                    <button mat-flat-button color="warn" (click)="atualizarPrecosExcel()">
                        <mat-icon>clear</mat-icon> Cancelar atualização
                    </button>
                </div>

                <div class="col-auto" *ngIf="atualizarExcel">
                    <button type="button" class="btn btn-success" (click)="baixarPlanilhaModelo()">
                        <div class="config">
                            <img src="./assets/file-excel-solid.svg" style="height: 18px;">
                            <span style="margin-left: 5px; margin-top: 25px;"> Planilha modelo</span>
                        </div>
                    </button>
                </div>
            </div>
        </form>


        <div *ngIf="atualizarExcel">
            <div class="row mt-4">
                <div class="col-sm">
                    <input id="file-input" type="file" (change)="fileChangeEvent($event)" accept=".xlsx"
                        style="width: 500px;" />
                </div>
            </div>
        </div>

        <div class="row mt-2" *ngIf="!bConsulta && bTabela">
            <mat-divider></mat-divider>
        </div>

        <div class="row mt-2" *ngIf="!bConsulta && bTabela">
            <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Filtro</mat-label>
                    <input id="inputFiltro" [(ngModel)]="filtroTabela" matInput (keyup)="aplicarFiltroTabela($event)"
                        placeholder="Filtro" autofocus>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-2" *ngIf="!bConsulta && bTabela">
            <div class="col-sm">
                <table mat-table [dataSource]="produtosSource" class="mat-elevation-z2" *ngIf="!bConsulta">

                    <ng-container matColumnDef="Codigo">
                        <th mat-header-cell *matHeaderCellDef> Código </th>
                        <td mat-cell *matCellDef="let element"> {{element.CodigoProduto}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Descrição (Nome) </th>
                        <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Grupo">
                        <th mat-header-cell *matHeaderCellDef> Grupo </th>
                        <td mat-cell *matCellDef="let element"> {{element.Grupo}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Valor">
                        <th mat-header-cell *matHeaderCellDef> Valor </th>
                        <td mat-cell *matCellDef="let element"> {{element.ValorString}} </td>
                    </ng-container>

                    <ng-container matColumnDef="QntEstoque">
                        <th mat-header-cell *matHeaderCellDef> Qnt. Estoque </th>
                        <td mat-cell *matCellDef="let element"> {{element.QuantidadeEstoque}} </td>
                    </ng-container>


                    <ng-container matColumnDef="Consultar">
                        <th mat-header-cell *matHeaderCellDef> Consultar </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Expandir" (click)="detalharProduto(element)"
                                class="iconbutton" color="primary">
                                <mat-icon aria-label="Expandir">search</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="detalharProduto(row)"></tr>

                    <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="6" style="text-align: center;">Não há produtos cadastrados no
                            sistema ou com o filtro definido
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 15, 20, 25, 50, 100, 200]"></mat-paginator>
            </div>
        </div>
    </mat-card-content>





    <!--Consulta detalhada-->
    <mat-card-content *ngIf=bConsulta>
        <div class="row">
            <div class="col-sm">
                <mat-horizontal-stepper labelPosition="bottom" #stepper>

                    <!-- Etapa 1 -->
                    <mat-step>
                        <form [formGroup]="produtoForm">
                            <ng-template matStepLabel>Informações Primárias</ng-template>
                            <div class="row">
                                <div class="col-auto ml-2">
                                    <div class="custom-checkbox custom-control">
                                        <input type="checkbox" formControlName="status" id="remember"
                                            class="custom-control-input">
                                        <label for="remember" class="custom-control-label">
                                            <div style="margin-top: 3px;">Status</div>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-sm text-right mr-2">
                                    Cadastrado dia: <strong>{{f.dataHoraCadastro.value}}</strong>
                                </div>
                            </div>

                            <div class="borda">
                                <div class="row mt-4">
                                    <div class="col-sm-4">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>Tipo de Item</mat-label>
                                            <mat-select style="color: black;" formControlName="tipoItem"
                                                name="tipo_item" required>
                                                <mat-option *ngFor="let tipo of tipoItem" [value]="tipo.value">
                                                    {{tipo.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.tipoItem.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <div class="row">
                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>Unidade de Medida</mat-label>
                                                    <mat-select formControlName="unidade" name="unidade_medida"
                                                        required>
                                                        <mat-option *ngFor="let unidade of unidadesMedidas"
                                                            [value]="unidade.value">
                                                            {{unidade.name}}
                                                        </mat-option>
                                                    </mat-select>

                                                    <mat-error *ngIf="f.unidade.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-1">
                                                <button class="bt_lateral" mat-icon-button color="primary"
                                                    aria-label="Novo Unidade de Medida" (click)="novoUnidadesMedida()">
                                                    <mat-icon class="mat-icon-custom">control_point</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-auto ml-2">
                                        <h1 class="customH1">Foto do Produto <div
                                                style="font-size: smaller; display: inline-block;">(520 x 410)</div>
                                        </h1>

                                        <div *ngIf="!f.img64.value">
                                            <button mat-stroked-button color="primary" (click)="uploadFoto()">
                                                <mat-icon>add_a_photo</mat-icon> Enviar foto
                                            </button>
                                        </div>

                                        <div class="row" *ngIf="f.img64.value">
                                            <div
                                                style="margin-top: 4px; background-color: #F0F0F0; border-radius: 5px; align-items: center; margin-left: 15px; ">
                                                <img style="max-height: 100px; margin: 4px" [src]="f.img64.value"
                                                    alt="Foto do Produto" />
                                            </div>

                                            <div style="display: inline-block; margin-top: 75px;">
                                                <button mat-stroked-button color="primary" (click)="uploadFoto()">
                                                    <mat-icon>mode_edit</mat-icon>
                                                </button>
                                            </div>

                                            <div style="display: inline-block; margin-top: 75px;">
                                                <button mat-stroked-button color="warn" matTooltip="Excluir foto"
                                                    (click)="deletarFoto()">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Descrição (Nome do Produto)</mat-label>
                                            <input type="text" matInput formControlName="nomeProduto" maxlength="100"
                                                (keypress)="omit_special_char($event)" required>
                                            <mat-hint *ngIf="bCaracterEspecial" align="start" style="color: red;">
                                                Não são permitidos acentos ou caracteres especiais </mat-hint>
                                            <mat-error *ngIf="f.nomeProduto.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <div class="row">

                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>Grupo</mat-label>
                                                    <mat-select formControlName="grupo" name="gp" required>
                                                        <mat-option *ngFor="let gp of grupos" [value]="gp.value">
                                                            {{gp.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.grupo.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-1">
                                                <button class="bt_lateral" mat-icon-button color="primary"
                                                    aria-label="Novo Grupo" (click)="novoProduto()">
                                                    <mat-icon class="mat-icon-custom">control_point</mat-icon>
                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="col-sm">
                                        <div class="row">

                                            <div class="col-sm">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>Fornecedor Preferencial</mat-label>
                                                    <mat-select formControlName="fornecedorPreferencial"
                                                        name="fornecedor_preferencial">
                                                        <mat-option *ngFor="let fornecedor of fornecedores"
                                                            [value]="fornecedor.value">
                                                            {{fornecedor.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.fornecedorPreferencial.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-1">
                                                <button class="bt_lateral" mat-icon-button color="primary"
                                                    aria-label="Novo Grupo" (click)="novoFornecedor()">
                                                    <mat-icon class="mat-icon-custom">control_point</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Descrição Complementar</mat-label>
                                            <input type="text" matInput formControlName="descricaoComplementar"
                                                maxlength="200" required>
                                            <mat-error *ngIf="f.descricaoComplementar.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-sm">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Referência</mat-label>
                                            <input type="text" matInput formControlName="referencia" maxlength="100">
                                            <mat-error *ngIf="f.referencia.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Código de Barras</mat-label>
                                            <input type="text" matInput formControlName="codigoBarras"
                                                (change)="validaCodigoBarras()" maxlength="13">
                                            <mat-error *ngIf="f.codigoBarras.errors?.required">
                                                Campo obrigatório
                                            </mat-error>
                                            <mat-error *ngIf="!f.codigoBarras.errors?.statusCodigoBarras">
                                                Este código já consta no sistema
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="row mt-4">
                            <div class="col-sm text-right">
                                <div class="row">
                                    <div class="col-sm text-right">
                                        <button mat-mini-fab color="warn" aria-label="Salvar" (click)="salvar()"
                                            matTooltip="Salvar" matTooltipClass="tooltip-red">
                                            <mat-icon>check</mat-icon>
                                        </button>
                                    </div>

                                    <div class="col-auto">
                                        <button mat-mini-fab color="primary" aria-label="Avançar"
                                            (click)="paginas(true, 1)" matTooltip="Avançar">
                                            <mat-icon>arrow_forward</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-step>


                    <!-- Etapa 2 -->
                    <mat-step [stepControl]="produtoForm">
                        <form [formGroup]="produtoForm">
                            <ng-template matStepLabel>Informações de Venda</ng-template>

                            <div class="row">
                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Valor</mat-label>
                                        <input matInput currencyMask
                                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                            formControlName="valor" maxlength="20"
                                            (ngModelChange)="alteracaoValor(true)" required>
                                        <mat-error *ngIf="f.valor.errors?.required">
                                            Campo obrigatório
                                        </mat-error>

                                        <mat-error *ngIf="f.valor.errors?.min">
                                            O Valor não pode ser R$ 0,00
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Valor Atacado</mat-label>
                                        <input matInput currencyMask
                                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                            formControlName="valorAtacado" maxlength="20"
                                            (ngModelChange)="alteracaoValor(false)">
                                        <mat-error *ngIf="f.valorAtacado.errors?.required">
                                            Campo obrigatório
                                        </mat-error>

                                        <mat-error *ngIf="f.valorAtacado.errors?.max">
                                            O valor atacado não pode ser maior do que o valor do produto
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Quantidade para Atacado</mat-label>
                                        <input type="number" matInput formControlName="quantidadeAtacado" [min]="0">
                                        <mat-error *ngIf="f.quantidadeAtacado.errors?.required">
                                            Campo obrigatório
                                        </mat-error>

                                        <mat-error *ngIf="f.quantidadeAtacado.errors?.min">
                                            A quantidade não pode ser 0
                                        </mat-error>
                                    </mat-form-field>
                                </div>


                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Quantidade Estoque</mat-label>
                                        <input type="number" matInput formControlName="quantidadeEstoque" [min]="0"
                                            maxlength="20">
                                        <mat-error *ngIf="f.quantidadeEstoque.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Qnt. mínima (Alerta estoque)</mat-label>
                                        <input type="number" matInput formControlName="quantidadeMinimaAlertaEstoque"
                                            [min]="0" maxlength="20">
                                        <mat-error *ngIf="f.quantidadeMinimaAlertaEstoque.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Qnt. Mínima (Venda)</mat-label>
                                        <input type="number" matInput formControlName="quantidadeMinima" [min]="0"
                                            maxlength="20">
                                        <mat-error *ngIf="f.quantidadeMinima.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Quantidade Máxima (Venda)</mat-label>
                                        <input type="number" matInput formControlName="quantidadeMaxima" [min]="0"
                                            maxlength="20">
                                        <mat-hint align="start"><strong>9999 para ilimitado</strong> </mat-hint>
                                        <mat-error *ngIf="f.quantidadeMaxima.errors">
                                            Campo obrigatório
                                        </mat-error>
                                        <mat-error *ngIf="f.quantidadeMaxima.errors?.min">
                                            O mínimo deve ser 1
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Identificador</mat-label>
                                        <input type="number" matInput formControlName="identificador" [min]="0"
                                            maxlength="20">
                                        <mat-error *ngIf="f.identificador.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Código</mat-label>
                                        <input type="number" matInput formControlName="codigo" [min]="0" maxlength="20"
                                            required>
                                        <mat-hint align="start"><strong>Parâmetro à confirmar</strong> </mat-hint>
                                        <mat-error *ngIf="f.codigo.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Lucro Bruto</mat-label>
                                        <input currencyMask
                                            [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                            matInput formControlName="lucroBruto" maxlength="20">
                                        <mat-error *ngIf="f.lucroBruto.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Comissão</mat-label>
                                        <input currencyMask
                                            [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                            matInput formControlName="comissao" maxlength="20">
                                        <mat-error *ngIf="f.comissao.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Custo de Compra</mat-label>
                                        <input matInput currencyMask
                                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                            formControlName="custoCompra" maxlength="20">
                                        <mat-error *ngIf="f.custoCompra.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-xs-auto col-md-2">
                                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                                        <mat-label>Custo Médio</mat-label>
                                        <input matInput currencyMask
                                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                            formControlName="custoMedio" maxlength="20">
                                        <mat-error *ngIf="f.custoMedio.errors">
                                            Campo obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>

                        <div class="row mt-4">
                            <div class="col-auto">
                                <button mat-mini-fab color="primary" aria-label="Voltar" (click)="paginas(false, 0)"
                                    matTooltip="Voltar">
                                    <mat-icon>arrow_back</mat-icon>
                                </button>
                            </div>

                            <div class="col-sm text-right">
                                <div class="row">
                                    <div class="col-sm text-right">
                                        <button mat-mini-fab color="warn" aria-label="Salvar" (click)="salvar()"
                                            matTooltip="Salvar" matTooltipClass="tooltip-red">
                                            <mat-icon>check</mat-icon>
                                        </button>
                                    </div>

                                    <div class="col-auto">
                                        <button mat-mini-fab color="primary" aria-label="Avançar"
                                            (click)="paginas(true, 2)" matTooltip="Avançar">
                                            <mat-icon>arrow_forward</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-step>

                    <!-- Etapa 3 -->
                    <!-- <mat-step [stepControl]="produtoForm">
                        <form [formGroup]="produtoForm">
                            <ng-template matStepLabel>Informações Tributárias</ng-template>
                            <div class="row">
                                <div class="col-sm">
                                    <div class="row mt-4">
                                        <div class="col-auto">
                                            <h1 class="customH1">Situação Tributária da NFe (Contribuinte)</h1>
                                        </div>
                                        <div class="col-sm">
                                            <hr />
                                        </div>
                                    </div>

                                    <div class="borda">
                                        <div class="row">
                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>CST NFe</mat-label>
                                                    <mat-select formControlName="cstNFe" name="cst_nfe"
                                                        matTooltip="Código de Situação Tributária - Nota Fiscal Eletrôica"
                                                        required>
                                                        <mat-option *ngFor="let cst of cstNFe" [value]="cst.CST"
                                                            [title]="cst.DESCRICAO">
                                                            {{cst.CST}} - {{cst.DESCRICAO}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.cstNFe.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>CSOSN NFe</mat-label>
                                                    <mat-select formControlName="csosnNFe" name="csosn_nfe"
                                                        matTooltip="Código de Situação da Operação do Simples Nacional - Nota Fiscal Eletrôica"
                                                        required>
                                                        <mat-option *ngFor="let csosnN of csosnNFe"
                                                            [value]="csosnN.CSOSN" [title]="csosnN.DESCRICAO">
                                                            {{csosnN.CSOSN}} - {{csosnN.DESCRICAO}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.csosnNFe.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>Taxa ICMS/ISS</mat-label>
                                                    <mat-select formControlName="taxaICMSISS" name="taxa_icms_iss"
                                                        matTooltip="Taxa de Circulação de Mercadorias e Prestação de Serviços / Imposto sobre o Serviço"
                                                        required>
                                                        <mat-option *ngFor="let tx of taxaICMSISS" [value]="tx.value">
                                                            {{tx.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.taxaICMSISS.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>CFOP NF</mat-label>
                                                    <mat-select formControlName="cfopNF" name="cfop_nf"
                                                        matTooltip="Código Fiscal de Operações e Prestações - Nota Fiscal"
                                                        required>
                                                        <mat-option *ngFor="let cfopNF of cfopNF" [value]="cfopNF.CFOP"
                                                            [title]="cfopNF.DESCRICAO">
                                                            {{cfopNF.CFOP}} - {{cfopNF.DESCRICAO}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.cfopNF.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm">
                                    <div class="row mt-4">
                                        <div class="col-auto">
                                            <h1 class="customH1">Situação Tributária NFCe (Cupom Eletrônico)</h1>
                                        </div>
                                        <div class="col-sm">
                                            <hr />
                                        </div>
                                    </div>

                                    <div class="borda">
                                        <div class="row">
                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>CST CFe</mat-label>
                                                    <mat-select formControlName="cstCFe" name="cst_cfe"
                                                        matTooltip="Código de Situação Tributária - Cupom Eletrôico"
                                                        required>
                                                        <mat-option *ngFor="let cst of cstCFe" [value]="cst.CST"
                                                            [title]="cst.DESCRICAO">
                                                            {{cst.CST}} - {{cst.DESCRICAO}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.cstCFe.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>CSOSN CFe</mat-label>
                                                    <mat-select formControlName="csosnCFe" name="csosn_cfe"
                                                        matTooltip="Código de Situação da Operação do Simples Nacional - Cupom Eletrôico"
                                                        required>
                                                        <mat-option *ngFor="let cosnC of csosnCFe" [value]="cosnC.CSOSN"
                                                            [title]="cosnC.DESCRICAO">
                                                            {{cosnC.CSOSN}} - {{cosnC.DESCRICAO}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.csosnCFe.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>Taxa ICMS/ISS CFe</mat-label>
                                                    <mat-select formControlName="taxaICMSISSCFe" name="taxa_icms_iss"
                                                        matTooltip="Taxa de Circulação de Mercadorias e Prestação de Serviços / Imposto sobre o Serviço - Cupom Eletrôico"
                                                        required>
                                                        <mat-option *ngFor="let txc of taxaICMSISSCFe"
                                                            [value]="txc.value">
                                                            {{txc.name}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.taxaICMSISSCFe.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-auto">
                                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                                    <mat-label>CFOP ECF</mat-label>
                                                    <mat-select formControlName="cfopECF" name="cfop_ecf"
                                                        matTooltip="Código Fiscal de Operações e Prestações - Escritura Contábill Fiscal"
                                                        required>
                                                        <mat-option *ngFor="let cfop of cfopECF" [value]="cfop.CFOP"
                                                            [title]="cfop.DESCRICAO">
                                                            {{cfop.CFOP}} - {{cfop.DESCRICAO}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="f.cfopECF.errors">
                                                        Campo obrigatório
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-auto">
                                    <h1 class="customH1">Demais Informações</h1>
                                </div>
                                <div class="col-sm">
                                    <hr />
                                </div>
                            </div>

                            <div class="borda">
                                <div class="row">
                                    <div class="col-auto">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>NCM</mat-label>
                                            <input type="text" matInput formControlName="ncm"
                                                matTooltip="Nomeclatura Comum do Mercosul" maxlength="8" required>
                                            <mat-error *ngIf="f.ncm.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>CEST</mat-label>
                                            <input type="text" matInput formControlName="cest"
                                                matTooltip="Código Especificador da Situação Tributária" maxlength="20">
                                            <mat-error *ngIf="f.cest?.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="row mt-4">
                            <div class="col-auto">
                                <button mat-mini-fab color="primary" aria-label="Voltar" (click)="paginas(false, 1)"
                                    matTooltip="Voltar">
                                    <mat-icon>arrow_back</mat-icon>
                                </button>
                            </div>

                            <div class="col-sm text-right">
                                <div class="row">
                                    <div class="col-sm text-right">
                                        <button mat-mini-fab color="warn" aria-label="Salvar" (click)="salvar()"
                                            matTooltip="Salvar" matTooltipClass="tooltip-red">
                                            <mat-icon>check</mat-icon>
                                        </button>
                                    </div>

                                    <div class="col-auto">
                                        <button mat-mini-fab color="primary" aria-label="Avançar"
                                            (click)="paginas(true, 3)" matTooltip="Avançar">
                                            <mat-icon>arrow_forward</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-step> -->

                    <!-- Etapa 4 -->
                    <!-- <mat-step [stepControl]="produtoForm">
                        <form [formGroup]="produtoForm">
                            <ng-template matStepLabel>Informações Gerais</ng-template>
                            <div class="borda">
                                <div class="row">
                                    <div class="col-xs-auto col-md-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>COFINS</mat-label>
                                            <input currencyMask
                                                [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                                matInput formControlName="cofins"
                                                matTooltip="Contribuição para o Financiamento da Seguridade Social"
                                                maxlength="20">
                                            <mat-error *ngIf="f.cofins.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CST COFINS</mat-label>
                                            <mat-select formControlName="cstCOFINS" name="csosn_cfe"
                                                matTooltip="Código Especificador da Situação Tributária - Contribuição para o Financiamento da Seguridade Social">
                                                <mat-option *ngFor="let cst_cofins of cstCOFINS"
                                                    [value]="cst_cofins.CST_COFINS">
                                                    {{cst_cofins.CST_COFINS}} - {{cst_cofins.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.cstCOFINS.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-xs-auto col-md-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>PIS</mat-label>
                                            <input currencyMask
                                                [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                                matInput formControlName="pis" matTooltip="Programa Integração Social"
                                                maxlength="20">
                                            <mat-error *ngIf="f.pis.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CST PIS</mat-label>
                                            <mat-select formControlName="cstPIS" name="csosn_cfe"
                                                matTooltip="Código Especificador da Situação Tributária - Programa Integração Social">
                                                <mat-option *ngFor="let cst_pis of cstPIS" [value]="cst_pis.CST_PIS">
                                                    {{cst_pis.CST_PIS}} - {{cst_pis.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.cstPIS.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Código ANP</mat-label>
                                            <input type="text" matInput formControlName="codigoANP" name="codAnp"
                                                matTooltip="Agência Nacional do Petróleo" maxlength="20">
                                            <mat-error *ngIf="f.codigoANP.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>


                            <div class="row mt-4">
                                <div class="col-auto">
                                    <h1 class="customH1">Natureza da Receita</h1>
                                </div>
                                <div class="col-sm">
                                    <hr />
                                </div>
                            </div>

                            <div class="borda">
                                <div class="row">
                                    <div class="col-xs-auto col-md-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>MVA</mat-label>
                                            <input currencyMask
                                                [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                                matInput formControlName="mva" matTooltip="Margem de Valor Agregado"
                                                maxlength="20">
                                            <mat-error *ngIf="f.mva.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-xs-auto col-md-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>ICMS Efetivo</mat-label>
                                            <input currencyMask
                                                [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                                matInput formControlName="icmsEfetivo"
                                                matTooltip="Imposto sobre Circulação de Mercadorias e Serviços"
                                                maxlength="20">
                                            <mat-error *ngIf="f.icmsEfetivo.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>IAT</mat-label>
                                            <input type="text" matInput formControlName="iat" name="iat"
                                                matTooltip="Índice de Arredondamento ou Truncamento" maxlength="20">
                                            <mat-error *ngIf="f.iat.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>IPPT</mat-label>
                                            <input type="text" matInput formControlName="ippt" name="ippt"
                                                matTooltip="Indicador de Produção Própria ou de Terceiro"
                                                maxlength="20">
                                            <mat-error *ngIf="f.ippt.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-auto">
                                    <h1 class="customH1">IPI</h1>
                                </div>
                                <div class="col-sm">
                                    <hr />
                                </div>
                            </div>

                            <div class="borda">
                                <div class="row">
                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>Tipo IPI</mat-label>
                                            <mat-select formControlName="tipoIPI" name="tipo_ipi"
                                                matTooltip="Imposto sobre Produtos Industrializados">
                                                <mat-option *ngFor="let tipo_IPI of tipoIPI" [value]="tipo_IPI.value">
                                                    {{tipo_IPI.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.tipoIPI.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-xs-auto col-md-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>IPI</mat-label>
                                            <input currencyMask
                                                [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                                matInput formControlName="ipi" maxlength="20">
                                            <mat-error *ngIf="f.ipi.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CST IPI</mat-label>
                                            <mat-select formControlName="cstIPI" name="cst_ipi"
                                                matTooltip="Código de Situação Tributária - Imposto sobre Produtos Industrializados">
                                                <mat-option *ngFor="let cst_ipi of cstIPI" [value]="cst_ipi.value">
                                                    {{cst_ipi.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.cstIPI.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CENQ</mat-label>
                                            <mat-select formControlName="cenq" name="cenq"
                                                matTooltip="Código de Enquadramento Legal do IPI">
                                                <mat-option *ngFor="let cenq_ of cenq" [value]="cenq_.CENQ">
                                                    {{cenq_.CENQ}} - {{cenq_.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.cenq.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-xs-auto col-md-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Exc.Fiscal</mat-label>
                                            <input type="text" matInput formControlName="excFiscal" maxlength="20">
                                            <mat-error *ngIf="f.excFiscal.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="row mt-4">

                            <div class="col-auto">
                                <button mat-mini-fab color="primary" aria-label="Voltar" (click)="paginas(false, 2)"
                                    matTooltip="Voltar">
                                    <mat-icon>arrow_back</mat-icon>
                                </button>
                            </div>

                            <div class="col-sm text-right">
                                <div class="row">
                                    <div class="col-sm text-right">
                                        <button mat-mini-fab color="warn" aria-label="Salvar" (click)="salvar()"
                                            matTooltip="Salvar" matTooltipClass="tooltip-red">
                                            <mat-icon>check</mat-icon>
                                        </button>
                                    </div>

                                    <div class="col-auto">
                                        <button mat-mini-fab color="primary" aria-label="Avançar"
                                            (click)="paginas(true, 4)" matTooltip="Avançar">
                                            <mat-icon>arrow_forward</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-step> -->

                    <!-- Etapa 5 -->
                    <mat-step [stepControl]="produtoForm">
                        <form [formGroup]="produtoForm">
                            <ng-template matStepLabel>Período Promocional</ng-template>
                            <div class="borda">
                                <div class="row">
                                    <div class="col-xs-auto col-md-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Valor</mat-label>
                                            <input matInput currencyMask
                                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                                formControlName="valorCopia" maxlength="20">
                                        </mat-form-field>
                                    </div>

                                    <div class="col-xs-auto col-md-2">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Valor Promocional</mat-label>
                                            <input matInput currencyMask
                                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                                formControlName="valorPromocional" maxlength="20"
                                                (ngModelChange)="alteracaoValorPromocional()">
                                            <mat-error *ngIf="f.valorPromocional.errors?.max">
                                                O valor promocional não pode ser maior do que o valor do produto
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                                            <mat-label>Período</mat-label>

                                            <mat-date-range-input [rangePicker]="picker">
                                                <input matStartDate placeholder="Data Inicial"
                                                    formControlName="periodoPromocionalInicial">
                                                <input matEndDate placeholder="Data Final"
                                                    formControlName="periodoPromocionalFinal">
                                            </mat-date-range-input>
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-date-range-picker #picker></mat-date-range-picker>

                                            <mat-error
                                                *ngIf="f.periodoPromocionalInicial.errors || f.periodoPromocionalFinal.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="row mt-4">
                            <div class="col-auto">
                                <button mat-mini-fab color="primary" aria-label="Voltar" (click)="paginas(false, 3)"
                                    matTooltip="Voltar">
                                    <mat-icon>arrow_back</mat-icon>
                                </button>
                            </div>

                            <div class="col-sm text-right">
                                <button mat-mini-fab color="warn" aria-label="Salvar" (click)="salvar()"
                                    matTooltipClass="tooltip-red" matTooltip="Salvar">
                                    <mat-icon>check</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-step>

                </mat-horizontal-stepper>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <mat-divider></mat-divider>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-auto">
                <button mat-flat-button color="warn" (click)="voltar()">
                    <mat-icon>clear</mat-icon> Cancelar
                </button>
            </div>
        </div>

    </mat-card-content>
</mat-card>